import React, { useState, useEffect } from 'react';

import Toolbar from '@lcsc-ui/components/ToolBar';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import useUserStore from '@lcsc-ui/store/user';
import { baseURL } from '@lcsc-ui/utils/baseUrl';
import ecpCurl from '@lcsc-ui/utils/ecpCurl';
import { Breadcrumb } from 'antd';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import OpApi from '@/apis/op';
import StaticdataApi from '@/apis/staticdata';
import InfoList from '@/features/info/InfoList';

export default function Index({ resourceData, websiteSectionList, catalogList, headerAd, infoList, keyword }) {
  const tagName = '应用与分享';
  const pathName = 'evaluate';
  const [logined, setLogined] = useState(false);
  const { updateUserInfo } = useUserStore();
  const [isOldCus, setIsOldCus] = useState(false); // 是否为老用户
  useEffect(() => {
    autoRefreshLoginInfo();
    setIsOldCus(resourceData?.commonConfigVO?.existSendOrder || false);
  }, []);
  const autoRefreshLoginInfo = (data) => {
    updateUserInfo(data);
    setLogined(true);
    window.isLogin = true;
  };
  const metadata = {
    title: `${tagName}_立创商城`,
    description:
      '立创商城SZLCSC.COM一站式电子元器件采购自营商城，拥有13万+平米智能化仓储，海量现货，正品保证，支持一键BOM配单，最快4小时发货，为用户提供电子元器件线上采购服务。嘉立创集团提供“EDA软件/PCB CAM软件、PCB智造、元器件商城、 激光钢网/治具 、SMT贴片”为一体的电子全产业链服务，助力全球硬件创新。',
    additionalMetaTags: [
      {
        name: 'keywords',
        content: '立创商城,元器件,电子元器件,电子元器件商城,电子元器件采购网,嘉立创',
      },
    ],
  };
  return (
    <>
      <NextSeo {...metadata}></NextSeo>
      <Head>
        <link rel="canonical" href={resourceData?.projectConfigVO.lcscWwwUrl + `/${pathName}/list.html`} />
      </Head>
      <BaseLayout
        resourceData={resourceData}
        websiteSectionList={websiteSectionList}
        catalogList={catalogList}
        headerAd={headerAd}
        isLgScreen={false}
        notIndexHeaderAdapter
        onlySScreen
        logined={logined}
        isNeedTopAd={true}
        isShowBottomAd={true}
      >
        <div className="w-full h-full bg-[#f8f8f8]">
          <section className="w-[1200px] mx-auto py-[16px]">
            <div className="flex w-full justify-between items-center">
              <Breadcrumb separator=">">
                <Breadcrumb.Item className="hover:!text-[#0093e6]" href={baseURL}>
                  首页
                </Breadcrumb.Item>
                <Breadcrumb.Item className="text-[#0093e6]">{tagName}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <InfoList list={infoList} keyword={keyword} pathName={pathName} tagName={tagName} />
          </section>
        </div>
        <Toolbar isOldCus={isOldCus}></Toolbar>
      </BaseLayout>
    </>
  );
}

export async function getServerSideProps(context) {
  const { req, query } = context;
  const [resourceData, catalogList, websiteSectionList, headerAd, infoList] = await Promise.all([
    ecpCurl(StaticdataApi.resourceList, { headers: req.headers }),
    ecpCurl(StaticdataApi.catalogList, { headers: req.headers }),
    ecpCurl(OpApi.websiteSection, { headers: req.headers }),
    ecpCurl(OpApi.advertisingHeader),
    ecpCurl(OpApi.evaluateList, {
      query: { keyword: query.keyword || '' },
    }),
  ]);
  return {
    props: {
      resourceData,
      websiteSectionList,
      catalogList,
      headerAd,
      infoList,
      keyword: query.keyword || '',
    },
  };
}
